import { openDB, promisifyRequest } from '../database/db';
import { dateUtils } from '../utils/dateUtils';

export const auditLogger = {
  log: async (projectId, action, entityType, entityId, details = {}) => {
    try {
      const db = await openDB();
      const tx = db.transaction('audit_logs', 'readwrite');
      const store = tx.objectStore('audit_logs');

      const entry = {
        id: 'aud-' + dateUtils.now() + '-' + Math.random().toString(36).substr(2, 4),
        projectId,
        action, // 'CREATE' | 'UPDATE' | 'DELETE' | 'EXPORT'
        entityType, // 'project' | 'quantitySheet' | 'soilTest' | 'file'
        entityId,
        timestamp: dateUtils.now(),
        details
      };

      await promisifyRequest(store.put(entry));
      return entry;
    } catch (e) {
      console.warn('[AuditLogger] Failed to write audit log:', e);
      return null;
    }
  },

  getByProject: async (projectId) => {
    const db = await openDB();
    const tx = db.transaction('audit_logs', 'readonly');
    const store = tx.objectStore('audit_logs');
    const index = store.index('projectId');
    const logs = await promisifyRequest(index.getAll(projectId));
    return (logs || []).sort((a, b) => b.timestamp - a.timestamp);
  }
};
